import {useEffect, useState} from "react";
import associateServices from "../../../services";
import Loading from "../../../components/loading";
import {useTranslation} from "react-i18next";
import moment from "moment/moment";
import Big from "big.js";
import InstrumentIcon from "../../../components/instrument-icon";
import TableFooter from "../../../components/table-footer/TableFooter";
import NoData from "../../../components/no-data";
import SlimSelect from 'slim-select'

const TransactionsReloads = (props) => {
    const [loading, setLoading] = useState(true)
    const [data, setData] = useState([])
    const [total, setTotal] = useState(0)
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(10)

    const {t} = useTranslation()
    useEffect(() => {
        new SlimSelect({
            select: '#select-count',
            events: {
                afterChange: newVal => setLimit(newVal[0].value)
            },
            settings: {
                showSearch: false,
            }
        });
    }, [])
    useEffect(() => {
        setLoading(true)


        associateServices.getReloadHistory({
            limit,
            page
        }).then(res => {
            setData(res?.data?.data || [])
            setTotal(res?.data?.total || 0)

            setLoading(false)

        })
    }, [page, limit])
    const handlePrev = () => {
        setPage(prevState => prevState <= 1 ? 1 : prevState - 1)
    }
    const handleNext = () => {
        setPage(prevState => prevState + 1)
    }
    return (
        <div className="tab-pane fade show active">
            <div className="table-wrap__head">
                <h3 className="settings__title">
                    <span>{t('transactions.reloads.title')}</span>
                </h3>
                <select
                    name="lines"
                    id="select-count"
                    className="table-wrap__select"
                    disabled={data?.length <= 0}
                >
                    <option value={'10'}>10</option>
                    <option value={'15'}>15</option>
                    <option value={'20'}>20</option>
                </select>
            </div>

            <div className="tab-content">
                {
                    loading ? <Loading/> :
                        <div className="tab-pane fade show active">
                            <>
                                <div className="table-responsive">

                                    {
                                        data?.length <= 0 ? <NoData desc={t('transactions.reloads.empty')}/> :
                                            <table className="xtable xtable--small">
                                                <thead>
                                                <tr>
                                                    <th>{t('transactions.reloads.table.time')}</th>
                                                    <th>{t('transactions.reloads.table.before_balance')}</th>
                                                    <th>{t('transactions.reloads.table.amount')}</th>
                                                    <th>{t('transactions.reloads.table.after_balance')}</th>
                                                </tr>
                                                </thead>
                                                <tbody>

                                                {
                                                    data?.map(debit => (
                                                        <tr key={debit?.id}>

                                                            <td>
                                                                <div className="xtable__text">

                                                    <span className="xtable__text-date">
                                                                        {moment.unix(debit?.timestamp || 0).format('MMMM Do')}

                                                        <small>
                                                                        {moment.unix(debit?.timestamp || 0).format('h:mm:ss a')}
                                                                    </small>
                                                                    </span>

                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="xtable__text ">
                                                                    {Big(debit?.before_amount || 0).toFixed(8)}
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <div
                                                                    className="xtable__coin xtable__text--green fw-bold">
                                                                    <InstrumentIcon code={debit?.wallet?.code}/>
                                                                    {Big(debit?.wallet_amount || 0).toFixed(8)}
                                                                </div>
                                                            </td>


                                                            <td>
                                                                <div className="xtable__text ">
                                                                    {Big(debit?.after_amount || 0).toFixed(8)}
                                                                </div>
                                                            </td>


                                                        </tr>
                                                    ))
                                                }

                                                </tbody>
                                            </table>
                                    }

                                </div>
                                {
                                    total > 0 &&
                                    <TableFooter
                                        total={total}
                                        limit={limit}
                                        handlePrev={handlePrev}
                                        handleNext={handleNext}
                                        page={page}
                                        section={'reload'}
                                        buttonText={t('transactions.reloads.table.download')}/>
                                }
                            </>

                        </div>
                }
            </div>
        </div>
    )
}

export default TransactionsReloads
